import { travelerApi } from "@apac/travelers";

export const travelerReducers = {
  [travelerApi.reducerPath]: travelerApi.reducer,
};

export const travelerMiddleware = [travelerApi.middleware];
